import CloseIcon from '@mui/icons-material/Close';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, IconButton, Typography } from '@mui/material';
import { lightGrey } from '@stack/theme';

import { truncateFilename } from '../../helpers/truncateFilename';

import { UploadedFileProps } from './props';

const UploadedFile = ({
  icon,
  fileName,
  file,
  fileSize,
  removeButtonProps,
  fileNameProps,
  fileSizeProps,
  ...props
}: UploadedFileProps) => {
  const previewURL = URL.createObjectURL(file);

  // ======================= VIEWS
  return (
    <Box
      className={'flex items-start justify-between py-[12px]'}
      sx={{
        border: 2,
        borderColor: lightGrey,
        borderRadius: '8px',
      }}
      {...props}
    >
      <Box
        className={'flex items-center'}
        sx={{ cursor: 'pointer' }}
        onClick={() => window.open(previewURL, '_blank')}
      >
        <Box {...props} className={'flex items-center p-[8px]'}>
          {icon ? icon : <DescriptionOutlinedIcon />}
        </Box>
        <Box className={'flex content-center flex-col'}>
          <Typography fontSize={'.875rem'} {...fileNameProps}>
            {truncateFilename(fileName)}
          </Typography>
          <Typography
            variant={'caption'}
            color={'secondary'}
            {...fileSizeProps}
          >
            {fileSize}
          </Typography>
        </Box>
      </Box>
      <IconButton
        {...removeButtonProps}
        className="!pt-[3px] "
        sx={{ zIndex: 2 }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default UploadedFile;
